module.exports = __webpack_public_path__ + "media/svg-new/potion-3-0f2db5ad.svg";